import { Wrench, Phone, Mail, MapPin } from "lucide-react";
import { BUSINESS, SERVICES } from "@/data/site";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-800 bg-zinc-950" data-testid="footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-3 lg:px-8">
        <div>
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center bg-orange-600 text-white">
              <Wrench className="h-5 w-5" />
            </span>
            <span className="font-display text-lg font-extrabold uppercase tracking-tight text-white">
              {BUSINESS.name}
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-zinc-500">
            Rural contracting — windmills, irrigation, tanks, filters, fencing and bores.
            Free written quotes on every job.
          </p>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">Services</h4>
          <ul className="mt-4 grid grid-cols-1 gap-2">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <a
                  href="#services"
                  className="text-sm text-zinc-400 transition-colors duration-150 hover:text-orange-500"
                  data-testid={`footer-service-${s.id}`}
                >
                  {s.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">Contact</h4>
          <ul className="mt-4 flex flex-col gap-3 text-sm text-zinc-400">
            <li className="flex items-center gap-3" data-testid="footer-phone">
              <Phone className="h-4 w-4 text-orange-500" /> {BUSINESS.phone}
            </li>
            <li className="flex items-center gap-3" data-testid="footer-email">
              <Mail className="h-4 w-4 text-orange-500" /> {BUSINESS.email}
            </li>
            <li className="flex items-center gap-3" data-testid="footer-area">
              <MapPin className="h-4 w-4 text-orange-500" /> {BUSINESS.area}
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-800">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-2 px-6 py-6 text-xs text-zinc-600 sm:flex-row sm:items-center lg:px-8">
          <span data-testid="footer-copyright">
            © {new Date().getFullYear()} {BUSINESS.name}. Fully licensed &amp; insured.
          </span>
          <a href="#quote" className="font-bold uppercase tracking-wider text-orange-500 hover:text-orange-400" data-testid="footer-quote-link">
            Get a free quote →
          </a>
        </div>
      </div>
    </footer>
  );
}
